import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { NotificationsNone, Person } from '@mui/icons-material';
import { IconButton, Badge, Avatar } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AuthContext from '../../AuthContext';

const Topbar = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const auth = useContext(AuthContext);

  // List of pages for suggestions (excluding dynamic routes like DriveDetails)
  const pages = [
    { name: 'Dashboard', path: '/' },
    { name: 'Disk Erasure', path: '/disk-erasure' },
    { name: 'Activity Log', path: '/activity-log' },
    { name: 'File Explorer', path: '/file-explorer' },
    { name: 'Disk Encryption', path: '/disk-encryption' },
  ];

  // Filter pages based on search term
  const suggestions = pages.filter(page =>
    page.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle search input change
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setShowSuggestions(value.length > 0);
  };

  // Handle suggestion click or Enter key
  const handleSelectSuggestion = (path) => {
    setSearchTerm('');
    setShowSuggestions(false);
    navigate(path);
  };

  // Handle Enter key press
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && suggestions.length > 0) {
      handleSelectSuggestion(suggestions[0].path);
    }
  };

  // Map userType to display text
  const getUserTypeDisplay = (userType) => {
    if (userType === 'ad') return 'Admin';
    if (userType === 'sa') return 'Super Admin';
    return userType; // Fallback to raw userType if not ad or sa
  };

  return (
    <div className="flex items-center justify-between p-4 bg-white shadow-sm">
      {/* Search Bar */}
      <div className="relative w-1/3">
        <SearchIcon className="text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5" />
        <input
          type="text"
          placeholder="Search"
          className="rounded-full pl-10 pr-4 py-2 w-full text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
          value={searchTerm}
          onChange={handleSearchChange}
          onKeyPress={handleKeyPress}
          onFocus={() => searchTerm.length > 0 && setShowSuggestions(true)}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
        />
        {/* Suggestions Dropdown */}
        {showSuggestions && suggestions.length > 0 && (
          <ul className="absolute top-full left-0 w-full bg-white border border-gray-200 rounded-md shadow-lg mt-1 max-h-60 overflow-y-auto z-10">
            {suggestions.map((page, index) => (
              <li
                key={index}
                className="px-4 py-2 text-sm text-gray-700 hover:bg-orange-100 cursor-pointer"
                onMouseDown={() => handleSelectSuggestion(page.path)}
              >
                {page.name}
              </li>
            ))}
          </ul>
        )}
      </div>

      {/* Right Side Icons */}
      <div className="flex items-center gap-4">
        {/* <IconButton>
          <Badge badgeContent={1} color="error">
            <NotificationsNone className="text-gray-600" />
          </Badge>
        </IconButton> */}
        

        

        {/* User Info */}
        <div className="flex flex-col items-start leading-tight">
          <span className="text-sm font-semibold text-gray-700">{auth.username}</span>
          <span className="text-xs bg-[#FFF3E5] text-[#FF7A00] px-2 py-0.5 rounded-md">
            {getUserTypeDisplay(auth.userType)}
          </span>
        </div>

         {/* User Icon */}
        <IconButton sx={{ backgroundColor: '#FFF3E5' }}>
          <Person className="text-[#FF7A00]" />
        </IconButton>

      
      </div>
    </div>
  );
};

export default Topbar;